import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import OrderDetailPageTypeLink from "@insite/content-library/Components/OrderDetailPageTypeLink";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    text: string | number;
    extendedStyles?: SmallHeadingAndTextStyles;
    isOsnQuoteListPage?: boolean;
    osnQuoteDetailsPageUrl?: string;
}
export interface SmallHeadingAndTextStyles {
    wrapper?: InjectableCss;
    heading?: TypographyProps;
    text?: TypographyProps;
    extendedStyles?: SmallHeadingAndTextStyles;
}

export const smallHeadingAndTextStyles: SmallHeadingAndTextStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;

            @media print {
                display: block;
            }
        `,
    },
    heading: {
        variant: "legend",
        css: css`
            color: ${getColor("text.main")};
            font-size: 12px !important;
            text-transform: uppercase;
            font-weight: 400;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 10px !important;
                        text-align: left;
                    `,
                    css`
                        font-size: 10px !important;
                        text-align: left;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    text: {
        css: css`
            width: 100%;
            font-size: 14px !important;
            text-transform: uppercase;
            /* line-height:5px; */
            font-weight: 500;
            ${wrapInContainerStyles}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 12px !important;
                        text-align: left;
                    `,
                    css`
                        font-size: 12px !important;
                        text-align: left;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
};

const CustomSmallHeadingAndText: React.FunctionComponent<OwnProps> = ({
    heading,
    text,
    extendedStyles,
    isOsnQuoteListPage,
    osnQuoteDetailsPageUrl,
    ...otherProps
}) => {
    const [styles] = React.useState(() => mergeToNew(smallHeadingAndTextStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.wrapper} {...otherProps}>
            <Typography as="p" {...styles.heading} data-test-selector="heading">
                {heading}
            </Typography>
            <Typography as="p" {...styles.text} data-test-selector={`text_${heading}`}>
                {text &&
                    (isOsnQuoteListPage ? (
                        <Link href={`${osnQuoteDetailsPageUrl}?quote=${text.toString()}`}>{text.toString()}</Link>
                    ) : (
                        <OrderDetailPageTypeLink title={text.toString()} orderNumber={text.toString()} />
                    ))}
            </Typography>
        </StyledWrapper>
    );
};

export default CustomSmallHeadingAndText;
